export default "__VITE_ASSET__DCTOHsfB__"